import React, { useState } from "react";
import { withI18n } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
// @ts-ignore
import { CWBModal } from "cwb-react";
import { toast } from "react-toastify";
import { Button, ButtonGroup } from "../Common";
import { iRootState } from "../../store";

interface Props extends StateProps {
  t?: any;
  hideModal: () => void;
  updateAuditionsStartOrder: (order: any) => void;
}

const UpdateOrderNumberModal = (props: Props) => {
  const [orderNumber, setOrderNumber] = useState(1);

  const { t } = props;

  const save = async (order: any) => {
    try {
      await props.updateAuditionsStartOrder(order);
      toast.success(t("Order numbers have been updated."), {
        position: "top-right",
      });
    } catch (error) {
      toast.error(t("Update failed. Please try again."), {
        position: "top-right",
        autoClose: false,
      });
    }
    props.hideModal();
  };
  let baseUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "";
  return (
    <StyledModal
      className="cwb-modal"
      isOpen={true}
      hideModal={() => props.hideModal()}
      buttons={
        <StyledButtonGroup>
          <Button onClick={() => save(orderNumber)}>
            <StyledSpan>

            {t("Save")}
              {props.loading && (
                <Spinner src={`${baseUrl}/images/spinner.svg`} />
              )}
            </StyledSpan>
          </Button>
          <Button variant="secondary" onClick={() => props.hideModal()}>
            {t("Cancel")}
          </Button>
        </StyledButtonGroup>
      }
    >
      <Title>{t("Numbering order")}</Title>
      <Text>
        {t(
          "Numbering will start at 1 by default. To adjust this enter an alternate number in the order start number box."
        )}
      </Text>
      <div>
        <TextBold>
          {t("Start order at")}:
          <StyledInput
            name="orderNum"
            type="number"
            value={orderNumber || ""}
            onChange={(e: any) => setOrderNumber(e.target.value)}
          />
        </TextBold>
      </div>
    </StyledModal>
  );
};

interface StateProps {
  loading: boolean;
}

const mapStateToProps = (state: iRootState) => {
  return {
    loading: state.kiosk.loading,
  };
};

const StyledModal = styled(CWBModal)`
  && {
    width: 600px;
    max-width: unset;
  }

  * {
    text-align: left;
  }
`;

const Title = styled.h1`
  color: #0a1f44;
  font-size: ${(p) => p.theme["xxl-font-size"]};
  font-weight: bold;
`;

const Text = styled.p`
  color: #53627c;
  font-size: 14px;
`;

const TextBold = styled.p`
  color: #53627c;
  font-size: 14px;
  font-weight: bold;
`;

const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

const StyledSpan = styled.span`
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  & > img {
    margin-left: 4px;
  }
`;

const Spinner = styled.img`
  width: 16px;
`;

const StyledInput = styled.input`
  height: 35px;
  width: 75px;
  background: #ffffff;
  border: 1px solid #d1d5dd;
  box-sizing: border-box;
  border-radius: 4px;
  outline: 0 !important;
  box-shadow: none !important;
  padding: 16px;
  margin: 0 0 0 14px;
`;

export default withI18n()(
  connect(mapStateToProps)(UpdateOrderNumberModal));
